<template>
  <span class="editable" v-bind:class="{ active }" @click="select">
    <slot name="prefix"></slot>
    <span
      ref="input"
      contenteditable="plaintext-only"
      @input="e => {
        if (isValid(e.target.innerText)) {
          $emit('input', e.target.innerText);
          e.target.parentNode.classList.remove('error--text');
        } else {
          e.target.parentNode.classList.add('error--text');
        }
      }"
      @focus="e => {
        active = true;
        select();
      }"
      @blur="e => {
        e.target.innerText = value;
        e.target.parentNode.classList.remove('error--text');
        active = false;
      }"
      @keydown.enter.prevent="e => e.target.blur()"
    />
    <slot name="suffix" v-bind:active="active"></slot>
  </span>
</template>


<style scoped>
.editable {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.editable:hover {
  text-decoration: underline;
  text-underline-offset: 1px;
  text-decoration-thickness: 1px;
}
.editable.active {
  text-decoration: underline;
  text-decoration-thickness: 2px;
}
.editable.active > [contenteditable] {
  cursor: text;
  outline: none;
  user-select: auto;
}
</style>


<script>
export default {
  name: 'content-editable-inline',

  props: [ 'value', 'rules' ],

  data() {
    return {
      active: false
    };
  },

  methods: {
    isValid(v) {
      for (const r of this.rules)
        if (!r(this.$refs.input.innerText))
          return false;
      return true;
    },

    async select() {
      await new Promise(setTimeout);
      if (!this.$refs.input)
        return;
      const r = document.createRange();
      r.selectNodeContents(this.$refs.input);
      const s = window.getSelection();
      s.removeAllRanges();
      s.addRange(r);
    }
  },

  watch: {
    value: {
      immediate: true,
      async handler(v) {
        await this.$nextTick();
        const el = this.$refs.input;
        if (el && (String(v) != el.innerText))
          el.innerText = v;
      }
    },
  }
}
</script>
